export enum OneTrustStatus {
    UNFETCHED = 'UNFETCHED',
    FETCHING = 'FETCHING',
    INITIALISED = 'INITIALISED',
    ERROR = 'ERROR',
}

export enum OneTrustConsentModel {
    OPT_IN = 'opt-in',
    OPT_OUT = 'opt-out',
}

// Action types
export enum OneTrustActionTypes {
    ONE_TRUST_SET_STATUS = 'ONE_TRUST_SET_STATUS',
    ONE_TRUST_SHOW_BANNER = 'ONE_TRUST_SHOW_BANNER',
    ONE_TRUST_HIDE_BANNER = 'ONE_TRUST_HIDE_BANNER',
    ONE_TRUST_SET_CONSENT_MODEL = 'ONE_TRUST_SET_CONSENT_MODEL',
}
